import { useContext } from 'react';
import { MeContext } from '../../../context/MeContext';
import { useMediaQuery } from '@chakra-ui/react';
import TeamInvitationRow from './TeamInvitationRow';
import TableBox from '../../common/TableBox';
import { Table, Thead, Tbody, Tr, Th } from '@chakra-ui/react';

const TeamInvitationTable = ({
  invitations,
  handleResendInvitation,
  getEntityName,
}) => {
  const [isLargerThan2XL] = useMediaQuery('(min-width: 96em)');
  const [isLargerThanXS] = useMediaQuery('(min-width: 30em)');
  const meContext = useContext(MeContext);
  const isOrgAdmin = meContext.isOrgAdmin();
  const isAdmin = meContext.isAdmin();

  return (
    <TableBox>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th display={isLargerThan2XL ? 'table-cell' : 'none'}>Role</Th>
            {isOrgAdmin && (
              <Th display={isLargerThan2XL ? 'table-cell' : 'none'}></Th>
            )}
            {isAdmin && (
              <Th display={isLargerThan2XL ? 'table-cell' : 'none'}></Th>
            )}
            <Th display={!isLargerThan2XL ? 'table-cell' : 'none'}></Th>
          </Tr>
        </Thead>
        <Tbody>
          {invitations.map((invitation, index) => (
            <TeamInvitationRow
              key={index}
              invitation={invitation}
              handleResendInvitation={handleResendInvitation}
              getEntityName={getEntityName}
            />
          ))}
        </Tbody>
      </Table>
    </TableBox>
  );
};

export default TeamInvitationTable;
